/**
 * QR Tarama Ses Efekti
 *
 * Web Audio API ile programatik "bip" sesi üretir.
 * iOS Safari dahil tüm modern tarayıcılarda çalışır (kullanıcı etkileşimi sonrası).
 * Ek dosya indirmesi gerektirmez — sıfır network maliyeti.
 */
let audioContext: AudioContext | null = null

export function playScanBeep(): void {
  try {
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
    }
    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)

    oscillator.type = 'sine'
    oscillator.frequency.setValueAtTime(1800, audioContext.currentTime)
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.15)

    oscillator.start(audioContext.currentTime)
    oscillator.stop(audioContext.currentTime + 0.15)
  } catch {
    // Ses çalınamazsa sessiz devam et
  }
}
